module.exports = __webpack_public_path__ + "images/category_lp/earphone/new/store_images/3@2x_c08abf6082d1d9e543ea4de7a02b7beb.png";